import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
	state: {
		menuOpen: false,
		connectionError: false,
	},
	mutations: {
		openMenu: (state, open) => {
			state.menuOpen = open;
		},
		setConnectionError(state, connectionError) {
			state.connectionError = connectionError;
		},
	},
	actions: {
		openMenu ({commit}) {
			commit('openMenu', true);
		},
		closeMenu ({commit}) {
			commit('openMenu', false);
		},
		setConnectionError({commit}, {connectionError}) {
			return new Promise((resolve, reject) => {
				commit('setConnectionError', connectionError);
				if (connectionError) {
					// eslint-disable-next-line
					// console.log('Session expired, must log again');
				}
				resolve();
			});
		},
	}, getters: {
		isMenuOpen: state => state.menuOpen,
		isConnectionError: state => state.connectionError,
	}
}
